import { CommonModule, DOCUMENT } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  KtdGridComponent,
  KtdGridItemResizeEvent,
  KtdGridLayout,
  KtdGridLayoutItem,
  KtdGridModule,
  ktdTrackById,
} from '@katoid/angular-grid-layout';
import {
  catchError,
  debounceTime,
  forkJoin,
  fromEvent,
  map,
  merge,
  of,
  Subscription,
} from 'rxjs';
import Chart, { Legend, plugins } from 'chart.js/auto';
import { LinealChartComponent } from '../../utils/lineal-chart/lineal-chart.component';
import { BarChartComponent } from '../../utils/bar-chart/bar-chart.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuPanelComponent } from '../../utils/menu-panel/menu-panel.component';
import { CustomTableComponent } from '../../utils/custom-table/custom-table.component';
import { DashboardPanel } from '../../models/panel';
import { LoaderComponent } from '../../utils/loader/loader.component';
import { DashboardServicesService } from '../../services/dashboard-services.service';
import { userInfo } from 'os';
import { response } from 'express';
import { jwtDecode } from 'jwt-decode';
import { TopbarComponent } from "../../utils/topbar/topbar.component";
import { LoginUserModel } from '../../models/loginUserModel';
import { DataSharingService } from '../../data-sharing.service';


import { NotificationService } from '../../services/notification.service';
import { IdleUserService } from '../../services/idle.service';
import { ThemeService } from '../../theme.service';
import { Title } from '@angular/platform-browser';
import { OutsideClickDirective } from '../../outside-click.directive';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DevicesService } from '../../services/devices.service';

@Component({
    selector: 'app-dashboard',
    imports: [DialogModule, ButtonModule, 
        CommonModule,
        KtdGridModule,
        LinealChartComponent,
        BarChartComponent,
        MenuPanelComponent,
        CustomTableComponent,
        LoaderComponent,
        OutsideClickDirective
    ],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  @ViewChild(KtdGridComponent, { static: false }) grid!: KtdGridComponent;
  @ViewChild('toggleButton')
  toggleButton!: ElementRef;
  @ViewChild('toggleButtonIcon')
  toggleButtonIcon!: ElementRef;
  @ViewChild('menu') menu!: ElementRef;
  paneles: DashboardPanel[] = [];
  cols = 8;
  rowHeight = 130;
  gap = 15;
  @Input() editable: boolean = false;
  hiddenMenuPanels = true;
  isFirstTime = false;
  step = 1;
  layoutFromPaneles: KtdGridLayout = [];
  loadingDashboard = false; 
  chartOptions: any ;
  showModalExpiration=false;
  showCardExpirationAlert = false;
  expiringCardsCount = 0;

  trackById = ktdTrackById;
  compactType: 'vertical' | 'horizontal' | null = 'vertical';
  layout: KtdGridLayout = [
    { id: '1', x: 0, y: 0, w: 2, h: 2, minW: 2, minH: 2, maxH: 2, maxW: 4 },
    { id: '2', x: 2, y: 0, w: 2, h: 2, minW: 2, minH: 2, maxH: 2, maxW: 4 },
    { id: '3', x: 4, y: 0, w: 2, h: 2, minW: 2, minH: 2, maxH: 2, maxW: 4 },
    { id: '4', x: 6, y: 0, w: 2, h: 2, minW: 2, minH: 2, maxH: 2, maxW: 4 },
    { id: '5', x: 0, y: 3, w: 4, h: 4, minW: 4, minH: 2, maxH: 4, maxW: 8 },
    { id: '6', x: 4, y: 3, w: 4, h: 4, minW: 4, minH: 4, maxH: 4, maxW: 8 },
    { id: '7', x: 0, y: 4, w: 4, h: 4, minW: 4, minH: 4, maxH: 4, maxW: 8 },
    { id: '8', x: 4, y: 4, w: 4, h: 4, minW: 4, minH: 4, maxH: 4, maxW: 8 }
  ];

  layoutSizes: { [id: string]: [number, number] } = {};
  endpoints: any[] = [];
  tokenAuth = "";
  data!: LoginUserModel;
  _subscription: any;
  private resizeSubscription!: Subscription;
  darkModeEnabled!: boolean;
  timeIdle: any;
  timeOut: any;
  isUserIdle: boolean = false;
  constructor(
    @Inject(DOCUMENT) public document: Document,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dashboardService: DashboardServicesService,
    private dataSharingService: DataSharingService,
    private idleUserService: IdleUserService,
    private notifyService: NotificationService,
     private themeService: ThemeService,
     private titleService:Title,
     private devicesService: DevicesService

  ) {
    this.titleService.setTitle("Tablero");
    this.themeService.setTitle("Tablero");
    this.darkModeEnabled = localStorage.getItem('theme') == "dark" ? true : false;
 
  

    this.dataSharingService.dashboardEditable.subscribe(value => {
      this.editable = value;
    });

    this._subscription = themeService.changeTheme.subscribe((value) => {
      this.darkModeEnabled = value;

    });

  
    this.data =JSON.parse(localStorage.getItem('data')!); 
    this.timeIdle = parseFloat(localStorage.getItem('iaTime')!);
    this.timeOut = parseFloat(localStorage.getItem('timeOut')!);


  }

  reset() {
  
    
    this.isUserIdle = false;
    this.idleUserService.reset();
  }

  ngOnInit(): void {
    this.editable=  this.dashboardService.getEditable();
    this.chartOptions= {
      y: {
        ticks: { color: this.darkModeEnabled?'white':'#182de7' },
        grid: {
          display: false
        }
      },
      x: {
        ticks: { color: this.darkModeEnabled?'white':'#182de7' },
        grid: {
          display: false
        }
      }
    };

    this.resizeSubscription = merge(
      fromEvent(window, 'resize'),
      fromEvent(window, 'orientationchange')
    )
      .pipe(debounceTime(50))
      .subscribe(() => {
        this.grid.resize();
        this.calculateLayoutSizes();
      });

    this.loadingDashboard = true;
    var thisWindow = this;
   
      this.dashboardService.getDashboard(this.data.User_id, this.data.Client_number).subscribe({
        next: (resp: DashboardPanel[]) => {
          this.paneles = resp;
          let i = 0;
          let visibleIndex = 0;
          let filteredPanel = this.paneles.filter((e) => e.hidden == false);

          for (i == 0; i < filteredPanel.length; i++) {
            let panel = filteredPanel[i];
          
            let panelSize = panel.size;
            this.endpoints.push({
              idPanel: filteredPanel.at(i)?.panelId,
              endpoint: filteredPanel.at(i)?.webMethod,
            });

            const y = i == 0 ? 0 : 0;
            const x = i == 0 ? 0 : filteredPanel[i - 1].size;
            this.layoutFromPaneles.push({
              id: panel.panelId.toString(),
              x: panel.x,
              y: panel.y,
              w: panel.size,
              h: panel.isTable || panel.isChart ? 4 : 2,
              minW: panel.isTable || panel.isChart ? 4 : 2,
              minH: panel.isTable || panel.isChart ? 4 : 2,
              maxH: panel.isTable || panel.isChart ? 6 : 2,
              maxW: panel.isTable || panel.isChart ? 8 : 4,
            });
          }

          this.layout = this.layoutFromPaneles;
          this.callEndpoints(this.endpoints);
        },
        error: (error) => {
        
        }
      });

      let today = new Date();
      
      let expDate = new Date(this.data.ExpirationDate);
      
      if(this.differenceInDays(today,expDate) < 10){
        this.showModalExpiration=true;
      }

      // Check expiring cards
      if (!sessionStorage.getItem('cardExpirationAlertShown')) {
        this.devicesService.getExpiringCards(this.data.Client_number).subscribe({
          next: (resp: any) => {
            if (resp?.length > 0) {
              this.expiringCardsCount = resp.length;
              this.showCardExpirationAlert = true;
              sessionStorage.setItem('cardExpirationAlertShown', 'true');
            }
          }
        });
      }
    
  }

  goToUpdate(){
    this.router.navigate(['app/restaurar/acceso']);
  }

  goToCardExpiration(){
    this.showCardExpirationAlert = false;
    this.router.navigate(['app/dispositivos']);
  }


  differenceInDays(date1:Date,date2:Date){
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
  
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }



  private calculateLayoutSizes() {
    const gridItemsRenderData = this.grid.getItemsRenderData();
    this.layoutSizes = Object.keys(gridItemsRenderData).reduce(
      (acc, cur) => ({
        ...acc,
        [cur]: [
          gridItemsRenderData[cur].width,
          gridItemsRenderData[cur].height
        ],
      }),
      {}
    );
  }

  onLayoutUpdated(layout: KtdGridLayout) {
    this.layout = layout;
   
    this.calculateLayoutSizes();
  }

  onGridItemResize(gridItemResizeEvent: KtdGridItemResizeEvent) {
 
    this.layoutSizes[gridItemResizeEvent.gridItemRef.id] = [
      gridItemResizeEvent.width,
      gridItemResizeEvent.height
    ];
    this.cd.detectChanges();
  }

  addPanel() {
    this.hiddenMenuPanels = false;
  }

  togglePanelMenu(e: any) {
    this.hiddenMenuPanels = true;
  }

  removePanel(panel: DashboardPanel) {
    panel.hidden = true;
    this.layout = this.ktdArrayRemoveItem(
      this.layout,
      (item) => item.id === panel.panelId.toString()
    );
  }

  stopEventPropagation(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  nextStep() {
  
  }

  ktdArrayRemoveItem<T>(array: T[], condition: (item: T) => boolean) {
    const arrayCopy = [...array];
    const index = array.findIndex((item) => condition(item));
    if (index > -1) {
      arrayCopy.splice(index, 1);
    }
    return arrayCopy;
  }

  addItemToLayout(event: DashboardPanel) {
    const nextId = event.panelId;
    event.x = 0;
    event.y = 0;
    const newLayoutItem: KtdGridLayoutItem = {
      id: nextId.toString(),
      x: event.x,
      y: event.y,
      w: event.size,
      h: event.isTable || event.isChart ? 4 : 2,
      minW: event.isTable || event.isChart ? 4 : 2,
      minH: event.isTable || event.isChart ? 4 : 2,
      maxH: event.isTable || event.isChart ? 6 : 2,
      maxW: event.isTable || event.isChart ? 8 : 4,
    };

    // Important: Don't mutate the array, create new instance. This way notifies the Grid component that the layout has changed.
    this.layout = [newLayoutItem, ...this.layout];

  }

  callEndpoints(endpoints: any[]) {
    const urls = this.paneles.map((p) =>
      this.dashboardService.infoPanel(p.webMethod, this.data.Client_number).subscribe({
        next: (resp: any) => {

          let panelFounded = this.paneles.findIndex(
            (panel) => panel.panelId == p.panelId
          );


          this.paneles.at(panelFounded)!.dataChart = this.applyChartColors(resp.dataChart);
          this.paneles.at(panelFounded)!.value = resp.value;
          this.paneles.at(panelFounded)!.labelsChart = resp.labelsChart;
          this.paneles.at(panelFounded)!.headers = resp.headers;
          this.paneles.at(panelFounded)!.items = resp.items;
        },
      })
    );

    merge(urls).subscribe({
      next: (resp: any) => {
  
        this.loadingDashboard = false;
      },
    });
  }

  saveDashboardLayout() {
    this.layout.forEach((panelLayout) => {
      let panelFounded = this.paneles.find(
        (p) => p.panelId.toString() == panelLayout.id
      );
      panelFounded!.x = panelLayout.x;
      panelFounded!.y = panelLayout.y;
      panelFounded!.size = panelLayout.w;
     
    });


    let hiddenPanels = this.paneles.filter(
      (p) => p.hidden == true
    );

    hiddenPanels.forEach((panelLayout) => {
      let panelFounded = this.paneles.find(
        (p) => p.panelId == panelLayout.panelId
      );
      panelFounded!.x = 0;
      panelFounded!.y = 0;
      panelFounded!.size = panelFounded!.isTable || panelFounded!.isChart ? 4 : 2;
  
    });



    this.dashboardService.saveDashboard(this.data.Client_number, this.data.User_id == 0 ? null : this.data.User_id, this.paneles).subscribe({
      next: (resp: any) => {
        
        this.loadingDashboard = false;
        this.dashboardService.setEditable('false')
      }
    });
    this.loadingDashboard = true;
  }

  clickOutside(isOut: any) {
    if (isOut) {
      this.showModalExpiration = false;
    }
  }

  private chartPalette = ['#4657ec', '#ffd500', '#11b7ee', '#57aa8a', '#f06292', '#7c4dff', '#ff7043'];

  applyChartColors(dataChart: any[]): any[] {
    if (!dataChart) return dataChart;
    return dataChart.map((ds: any, i: number) => ({
      ...ds,
      backgroundColor: ds.backgroundColor?.map ? this.chartPalette.slice(0, ds.backgroundColor.length) : [this.chartPalette[i % this.chartPalette.length]],
      borderColor: ds.borderColor ? this.chartPalette[i % this.chartPalette.length] : undefined,
      borderColors: ds.borderColors ? [this.chartPalette[i % this.chartPalette.length]] : undefined
    }));
  }
}
